import React from 'react';
import { Button, Select, Tabs, Row, Col, Progress } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReactComponent as VideoIcon } from '@/assets/icons/video.svg';
import { ReactComponent as AudioIcon } from '@/assets/icons/audio.svg';
import { ReactComponent as ImageIcon } from '@/assets/icons/image.svg';
import { ReactComponent as CloseIcon } from '@/assets/icons/close.svg';
import sentGAEvent from '@/ga';
import Utils from '@/utils';
import '@/assets/convert.less';

const { TabPane } = Tabs;

const ConvertWorkRender = ({
  video,
  audio,
  image,
  files,
  isConverted,
  handleConvertType,
  handleCloseFile,
  handleDownloadAll,
  handleSubmitAgain,
  type,
}) => {
  const { t } = useTranslation(['convert', 'common']);
  const dropdownRender = (file) => {
    const video_audioRender = (
      <Tabs defaultActiveKey={file.fileType === 'video' ? '1' : '2'}>
        <TabPane tab={t('Video')} key='1'>
          <Row gutter={[10, 10]} className='convert-tab-list'>
            {video.map((item) => (
              <Col key={'video' + item} span={12}>
                <div
                  className={
                    file.convertType === item &&
                    file.convertFileType === 'video'
                      ? 'active'
                      : null
                  }
                  onClick={() => handleConvertType(file.guid, 'video', item)}
                >
                  {item}
                </div>
              </Col>
            ))}
          </Row>
        </TabPane>
        <TabPane tab={t('Audio')} key='2'>
          <Row gutter={[10, 10]} className='convert-tab-list'>
            {audio.map((item) => (
              <Col key={'audio' + item} span={12}>
                <div
                  className={
                    file.convertType === item &&
                    file.convertFileType === 'audio'
                      ? 'active'
                      : null
                  }
                  onClick={() => handleConvertType(file.guid, 'audio', item)}
                >
                  {item}
                </div>
              </Col>
            ))}
          </Row>
        </TabPane>
      </Tabs>
    );
    const imageRender = (
      <Tabs defaultActiveKey='1'>
        <TabPane tab={t('Image')} key='1'>
          <Row gutter={[10, 10]} className='convert-tab-list'>
            {image.map((item) => (
              <Col key={'image' + item} span={12}>
                <div
                  className={
                    file.convertType === item &&
                    file.convertFileType === 'image'
                      ? 'active'
                      : null
                  }
                  onClick={() => handleConvertType(file.guid, 'image', item)}
                >
                  {item}
                </div>
              </Col>
            ))}
          </Row>
        </TabPane>
      </Tabs>
    );
    return file.fileType === 'video' || file.fileType === 'audio'
      ? video_audioRender
      : imageRender;
  };

  const iconRender = (fileType) => {
    if (fileType === 'video') {
      return <VideoIcon />;
    } else if (fileType === 'audio') {
      return <AudioIcon />;
    } else {
      return <ImageIcon />;
    }
  };

  const DownloadGaEvent = () => {
    let action;
    if (type === 'image') {
      action = '34IC_DownloadStart';
    } else if (type === 'audio') {
      action = '29AC_DownloadStart';
    } else {
      action = '36VC_DownloadStart';
    }
    if (action) {
      sentGAEvent({
        category: 'DownloadStart',
        action: action,
        label: 'Null',
      });
    }
  };
  const statusRender = (file) => {
    return file.status === 'converting' || file.status === 'uploading' ? (
      <Progress
        strokeColor='#8372FF'
        status='active'
        percent={
          file.proccess ? parseInt(file.proccess / file.proccessStep) : 0
        }
        format={(percent) =>
          `${
            file.status === 'uploading'
              ? t('common:Uploading')
              : t('Converting')
          }` +
          ' ' +
          percent +
          '%'
        }
      />
    ) : file.status === 'success' ? (
      <Button
        type='primary'
        onClick={() => {
          Utils.downloadFile(file, file.convertType);
          DownloadGaEvent();
        }}
      >
        {t('common:Download')}
      </Button>
    ) : file.status.indexOf('Failed') !== -1 ? (
      <Button type='primary' onClick={() => handleSubmitAgain(file.guid)}>
        {t('Retry')}
      </Button>
    ) : (
      <Button className='ready'>{t('Ready')}</Button>
    );
  };

  return (
    <div className='content'>
      <div className='list'>
        {files.map((item) => (
          <div key={item.guid} className='item'>
            <div className='info'>
              {iconRender(item.fileType)}
              <span>{Utils.omissionString(item.name, 5, 5)}</span>
            </div>
            <span>{(item.size / 1024 / 1024).toFixed(2)}MB</span>
            <div className='opar'>
              <span>{t('Convert to')}</span>
              <Select
                className='Convert-select'
                value={item.convertType}
                dropdownRender={() => dropdownRender(item)}
                //dropdownClassName="dark-select-dropdown"
                disabled={
                  item.status === 'success' ||
                  item.status === 'converting' ||
                  item.status === 'uploading'
                }
              ></Select>
              <div>{statusRender(item)}</div>
              <CloseIcon
                style={{ cursor: 'pointer' }}
                onClick={() => handleCloseFile(item.guid)}
              />
            </div>
          </div>
        ))}
      </div>
      {/* {isConverted && (
        <div className='btn-group'>
          <Button
            type='primary'
            size='large'
            onClick={() => {
              sentGAEvent({
                category: 'Download',
                action: 'ToolkitDownload',
                label: 'convertsuccess',
              });
            }}
            href={Utils.getHitPawToolKitEXELink()}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('Download Desktop')}
          </Button>
          <Button type='primary' ghost size='large' onClick={handleDownloadAll}>
            {t('Download All')}
          </Button>
        </div>
      )} */}
    </div>
  );
};

export default ConvertWorkRender;
